// extracted by mini-css-extract-plugin
module.exports = {"pagination":"pagination_1S-r8","width-100":"width-100_3ds9M"};